import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input, { InputAdornment } from 'material-ui/Input';
import Button from '../../components/Buttons';
import { FormControl } from 'material-ui/Form';
import SearchIcon from 'material-ui-icons/Search';
import './SearchGroup.css';


export default class InputSearch extends Component {
    static propTypes = {
        inputSearchHandler: PropTypes.func.isRequired,
        isResetSearch: PropTypes.bool.isRequired,
    };

    state = {
        search: '',
    };

    handleChange = () => event => {
        this.setState({ search: event.target.value });
    };

    componentDidUpdate(prevProps) {
        if (prevProps.isResetSearch !== this.props.isResetSearch && this.props.isResetSearch){
            this.setState({search: ''})
        }
    }

    render () {
        return (
            <div>
                <FormControl className="search__input--formControl" fullWidth>
                    <label className="sr-only" htmlFor="home_input_search">Book Search</label>
                    <Input
                        disableUnderline
                        className="search__input--inputTag"
                        placeholder="Search by Title, Author, ISBN or PRCID"
                        startAdornment={
                            <InputAdornment position="start">
                                    <SearchIcon className="search__input--icon" />
                            </InputAdornment>
                        }
                        id="home_input_search"
                        label="Search field"
                        value={this.state.search}
                        onChange={this.handleChange()}
                    />
                </FormControl>
                <Button
                    type="submit"
                    color="secondary"
                    disabled={!this.state.search}
                    variant="raised"
                    className="search__input--button"
                    onClick={ () => this.props.inputSearchHandler(this.state.search)}
                >
                    Search
                </Button>
            </div>
        );
    }
}
